<template>
  <v-form @submit.prevent="onSearch" class="pa-4">
    <v-row>
      <v-col cols="12">
        <v-card class="mx-auto" max-width="800" elevation="2">
          <v-card-text>
            <v-card-title class="text-h5 text-primary text-center">
              {{ $t('strings.search-data-sources') }}
            </v-card-title>
            <v-text-field
              v-model="searchQuery"
              :placeholder="$t('strings.search-data-sources')"
              variant="outlined"
              density="compact"
              hide-details
              clearable
              :loading="searchStore.loading"
              single-line
              color="primary"
              name="searchQuery"
            >
              <template v-slot:append-inner>
                <v-btn
                  variant="text"
                  density="comfortable"
                  icon="mdi-magnify"
                  color="secondary"
                  @click="onSearch"
                  :disabled="searchStore.loading"
                >
                </v-btn>
              </template>
            </v-text-field>
          </v-card-text>
          <v-card-text>
            <v-switch
              :label="$t('strings.deep-search')"
              v-model="isDeepSearch"
              density="compact"
              class="mx-2"
              color="primary"
              persistent-hint
              :hint="$t('strings.deep-search-hint')"
            ></v-switch>

            <v-alert
              v-if="searchStore.error"
              type="error"
              variant="tonal"
              class="mt-4"
              closable
              @click:close="searchStore.error = null"
            >
              {{ searchStore.error }}
            </v-alert>

            <v-alert
              v-if="searchStore.hasSearched && !searchStore.loading"
              type="success"
              variant="tonal"
              class="mt-4"
              closable
            >
              {{ $t('strings.search-completed') }}: {{ searchStore.totalResults }} {{ $t('strings.results-found') }}
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-form>
</template>

<script setup>
import { ref } from 'vue'
import { useSearchStore } from '@/stores/search'

const searchStore = useSearchStore()
const searchQuery = ref('')
const isDeepSearch = ref(false)

async function onSearch() {
  if (searchQuery.value.trim()) {
    await searchStore.searchDatasets(searchQuery.value, isDeepSearch.value)
  }
}
</script>

<style scoped>
/* Vuetify styles are applied via components */
</style>
